// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"8673c97c","787":"276fc59e"}[chunkId] + ".chunk.js";
};